
import Popup from 'vux/src/components/popup/index.vue'

import HeadBar from '../HeadBar/HeadBar';

export default {
name: 'hotel-filter',
components: {
Popup,

HeadBar,
},
props: {
isShow: {
type: Boolean,
default: false,
},
isShowSort: {
type: Boolean,
default: true,
}
},
data(){
return {
recommand: 1,
};
},
methods: {
/** 选择排序方式 */
onSetRecommand(event){
const {recommand} = event.target.dataset;

if(recommand){
this.recommand = recommand;
}
},

/** 重置筛选条件 */
onResetCondition(){
this.recommand = 1;
this.$emit('on-reset');
},

/** 确定筛选条件 */
onConfirmCondition(){

this.$emit('on-confirm', {sort_by: this.recommand});
this.onClosePopup();
},

/** 显示筛选 */
onShowFilterPopup(){
this.$emit('on-open-filter');
},

/** 关闭筛选 */
onClosePopup(){
this.$emit('on-close-filter');
},
}
}



// WEBPACK FOOTER //
// ./src/components/Filter/Filter.vue